export const LOAD_OVERVIEW = 'ADMIN_DASHBOARD/LOAD_OVERVIEW';
export const LOAD_USERS = 'ADMIN_DASHBOARD/LOAD_USERS';
export const LOAD_EVENTS = 'ADMIN_DASHBOARD/LOAD_EVENTS';
export const SET_OVERVIEW_LOADING = 'ADMIN_DASHBOARD/OVERVIEW_LOADING';
export const SET_USERS_LOADING = 'ADMIN_DASHBOARD/USERS_LOADING';
export const SET_EVENTS_LOADING = 'ADMIN_DASHBOARD/EVENTS_LOADING';
export const SET_OVERVIEW_ERROR = 'ADMIN_DASHBOARD/OVERVIEW_ERROR';
export const SET_USERS_ERROR = 'ADMIN_DASHBOARD/USERS_ERROR';
export const SET_EVENTS_ERROR = 'ADMIN_DASHBOARD/EVENTS_ERROR';

export const LOAD_NOMINEE_VOTES = 'ADMIN_DASHBOARD/LOAD_NOMINEE_VOTES';
export const SET_NOMINEE_VOTES_LOADING = 'ADMIN_DASHBOARD/NOMINEE_VOTES_LOADING';
export const SET_NOMINEE_VOTES_ERROR = 'ADMIN_DASHBOARD/NOMINEE_VOTES_ERROR';
export const CLEAR_NOMINEE_VOTES = 'ADMIN_DASHBOARD/CLEAR_NOMINEE_VOTES';

export const SET_PROMO_CREATE_LOADING = 'ADMIN_DASHBOARD/PROMO_CREATE_LOADING';
export const SET_PROMO_CREATE_ERROR = 'ADMIN_DASHBOARD/PROMO_CREATE_ERROR';
export const PROMO_CREATED = 'ADMIN_DASHBOARD/PROMO_CREATED';
export const CLEAR_PROMO_CREATED = 'ADMIN_DASHBOARD/CLEAR_PROMO_CREATED';
